import { render, staticRenderFns } from "./purchase-intentions-houses.vue?vue&type=template&id=143c7a82"
import script from "./purchase-intentions-houses.vue?vue&type=script&lang=ts"
export * from "./purchase-intentions-houses.vue?vue&type=script&lang=ts"
import style0 from "./purchase-intentions-houses.vue?vue&type=style&index=0&id=143c7a82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports